module.exports = __webpack_public_path__ + "img/05.9e419069.png";